import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { Section, SectionHeader } from "./ui/Section";
import AppStoreButtons from "./ui/AppStoreButtons";

const Activation = () => {
  const { activationTitle, activationDesc, activationMethods, downloadApp, appStore, googlePlay, compatibleMessage } = useContext(LanguageContext);

  return (
    <Section tone="light">
      <SectionHeader title={activationTitle} lead={activationDesc} />

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {activationMethods.map((method, index) => (
          <div key={index} className="rounded-2xl border border-brand-line bg-white p-6 transition-colors hover:border-brand-teal/40">
            <div className="mb-6 flex h-11 w-11 items-center justify-center rounded-full bg-brand-foam" aria-hidden="true">
              {React.cloneElement(method.icon, { size: 20, className: "text-brand-teal" })}
            </div>
            <h3 className="mb-2 font-display text-lg font-bold text-brand-navy">{method.title}</h3>
            <p className="mb-0 text-sm leading-relaxed text-slate-600">{method.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 flex flex-col items-start justify-between gap-6 rounded-[2rem] bg-brand-navy p-8 md:flex-row md:items-center md:p-10">
        <div>
          <h3 className="mb-2 font-display text-2xl font-bold text-white">{downloadApp}</h3>
          {compatibleMessage && <p className="mb-0 text-sm text-white/60">{compatibleMessage}</p>}
        </div>
        <AppStoreButtons appStore={appStore} googlePlay={googlePlay} tone="light" />
      </div>
    </Section>
  );
};

export default Activation;
